<template>
  <div id="list">

    <div id="new-category-modal" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Registrar nueva categoría</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="name">Nombre de la categoría</label>
              <input type="text" class="form-control" name="name" v-model="$v.form.name.$model">
              <template v-if="$v.form.name.$error">
                <div class="invalid-feedback" v-if="!$v.form.name.required">Este campo es obligatorio</div>
              </template>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-success" v-on:click="createCategory">Guardar categoría</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-6">
        <h4 class="font-weight-bold">Listado general de Normativas</h4>
      </div>
      <div class="col-12 col-lg-6 text-lg-right mb-3">
        <a href="javascript:;"
          class="btn btn-primary px-4 mr-3"
          data-toggle="modal"
          data-target="#new-category-modal">
          Nueva categoría
        </a>
        <router-link to="/normatividad/nueva" class="btn btn-success px-4">
          Nueva normatividad
        </router-link>
      </div>
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="keyword">Búsqueda rápida de normativas</label>
          <input type="text" class="form-control" placeholder="Busque por título, año, etc..." v-model.trim="keyword">
        </div>
      </div>
      <div class="col-12 col-lg-6 d-lg-flex align-items-center justify-content-lg-end">
        <span class="text-muted">Mostrando {{normativities.length}} resultados.</span>
      </div>
      <div class="col-12 mt-3">
        <div class="table-responsive">
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th>Fecha de creación</th>
                <th>Título</th>
                <th>Categoría</th>
                <th>Año</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!results.length">
                <td colspan="5">No se encontraron resultados.</td>
              </tr>
              <tr v-for="(normativity, index) in results"
              v-bind:key="index">
                <td>{{normativity.createdAt | date}}</td>
                <td>{{normativity.title}}</td>
                <td>{{getCategory(normativity.category)}}</td>
                <td>{{normativity.year}}</td>
                <td>
                  <a href="javascript:;"
                    class="text-primary mr-3"
                    v-on:click.prevent="handleUpdate(normativity.id)">
                    Ver / Modificar
                  </a>
                  <a href="javascript:;"
                    class="text-danger mr-3"
                    v-on:click.prevent="handleDelete(normativity.id)">
                    Eliminar
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firestore, } from "@/firebase";
  import { validationMixin, } from "vuelidate";
  import { required, } from "vuelidate/lib/validators";
  export default {
    mixins: [
      validationMixin,
    ],
    data() {
      return {
        categories: [],
        normativities: [],
        form: {
          name: "",
        },
        keyword: "",
      };
    },
    computed: {
      results() {
        return this.normativities.filter(normativity => normativity.title.trim().toLowerCase().includes(this.keyword.toLowerCase())
          || normativity.year.trim().toLowerCase().includes(this.keyword.toLowerCase())
        );
      }
    },
    validations: {
      form: {
        name: { required, },
      },
    },
    methods: {
      async getNormativityCategories() {
        try {
          this.categories = [];
          const snapshot = await firestore.collection("/normativity-categories").get();
          snapshot.forEach(doc => {
            this.categories.push({ ...doc.data(), id: doc.id, });
          });
        } catch(e) {
          console.error(e);
        }
      },
      getCategory(id) {
        const category = this.categories.find(category => category.id === id);
        return category ? category.name : "---";
      },
      async getNormativities() {
        this.normativities = [];
        const snapshot = await firestore.collection("/normativities").get();
        snapshot.forEach(async doc => {
          this.normativities.push({ ...doc.data(), id: doc.id, });
        });
      },
      handleUpdate(id) {
        this.$store.commit("SET_EDIT_NORMATIVITY", this.normativities.find(a => a.id == id));
        this.$router.push({
          name: "UpdateNormativity",
          params: { id, },
        });
      },
      async handleDelete(id) {
        const confirm = await this.$swal({
          title: "¿Seguro que deseas eliminar esta normativa?",
          buttons: ["Cancelar", "Confirmar"],
        });
        if (confirm)
          try {
            await firestore.doc(`/normativities/${id}`).delete();
            this.getNormativities();
            this.$swal("Operación exitosa", "Normativa eliminada con éxito", "success");
          } catch(e) {
            console.error(e);
            this.$swal("Error", e.toString(), "error");
          }
      },
      async createCategory() {
        this.$v.form.$touch();

        if (this.$v.form.$anyError)
          return;
        
        try {
          await firestore.collection("/normativity-categories").add({
            name: this.form.name,
            createdAt: new Date(),
            craetedBy: this.$store.state.user.uid,
          });
          setTimeout(() => window.location.reload(), 1000);
          this.$swal("Operación exitosa", "Categoría de normativa agregada con éxito", "success");
        } catch(e) {
          console.error(e);
          this.$swal("Error", e.toString(), "error");
        }
      }
    },
    async created() {
      await this.getNormativityCategories();
      await this.getNormativities();
    },
  };
</script>